(function () {
'use strict';

const STEP_ORDER = [
  'kits','bases','volantes','adicionais-volante-base','pedais','pedais-adicionais',
  'cambios-extras','suporte-monitor','adicionais-monitor','cockpits','acessorios','bancos','extras'
];
const CONDITIONAL_STEPS = {
  'adicionais-volante-base': 'volantes',
  'pedais-adicionais': 'pedais',
  'adicionais-monitor': 'suporte-monitor',
  'acessorios': 'cockpits',
  'bancos': 'cockpits'
};
const LABELS = {
  'kits': 'Kits','bases': 'Bases DD','volantes': 'Volantes',
  'adicionais-volante-base': 'Adicionais V&B','pedais': 'Pedais',
  'pedais-adicionais': 'Adicionais de Pedais','cambios-extras': 'Câmbios & Handbrake',
  'suporte-monitor': 'Suporte de Monitor','adicionais-monitor': 'Adicionais de Monitor',
  'cockpits': 'Cockpits','acessorios': 'Suportes','bancos': 'Bancos','extras': 'Extras'
};
/* "pedais-adicionais" (Adicionais de Pedais) adicionado à lista de categorias
   com múltipla seleção — antes só existia no data-multi do Liquid, mas quem
   realmente decide o comportamento de seleção é este Set. */
const MULTI_STEPS = new Set(['cambios-extras','adicionais-monitor','acessorios','extras','adicionais-volante-base','pedais-adicionais']);

const state = {
  platform: null,
  selections: {},   // step -> sel (single) OR step -> sel[] (multi)
  hiddenSteps: new Set(),
  openStep: 'platform',
  confirmedImage: null // { image, title, desc, price } — última seleção "de verdade" (não hover)
};

const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

/* ============================================================
   TABELA DE COMPATIBILIDADE — inalterada, mesma regra de negócio
   ============================================================ */
const G = {
  adicionais_monitor: ['suporte-extensor-para-4-monitor-1','suporte-extensor-para-3-monitores-1'],
  adicionais_volante_base: [
    'moza-clamp-for-truck-wheel','moza-12-inch-round-wheel-mod-for-es','moza-es-formula-wheel-mod',
    'moza-table-clamp','moza-quick-release-adapter','moza-e-stop-switch','moza-multi-function-stalks',
    'moza-base-extension-rod'
  ],
  bancos: [
    'banco-sprint-tecido-alcantara-camurca-para-estrutura-de-cockpit-copia',
    'banco-black-line-para-estrutura-de-cockpit-copia',
    'banco-nitro-com-almofada-lombar-para-estrutura-de-cockpi',
    'banco-black-line-para-estrutura-de-cockpit',
    'banco-sprint-tecido-alcantara-camurca-para-estrutura-de-cockpit',
    'banco-rosso-line-para-estrutura-de-cockpit'
  ],
  bases: [
    'moza-r21-ultra-direct-drive-wheel-base','moza-r12-v2-direct-drive-wheel-base',
    'moza-r9-v3-direct-drive-wheel-base','moza-r25-ultra-true-torque-dd-wheel-base'
  ],
  cambios: ['moza-hgp-shifter','moza-sgp-sequential-shifter','moza-hbp-freio-de-mao'],
  cockpits: [
    'cockpit-suzuka-aluminio-4081','cockpit-detroit-compact-dobravel','cockpit-zolder-monocoluna',
    'cockpit-spa','cockpit-profissional-interlagos','cockpit-monza-dobravel-3-geracao'
  ],
  extras: ['tapete-gamer-para-setup-de-cockpit','moza-universal-hub-kit','moza-cm2-hd-racing-dash'],
  kits: ['moza-r5-wheel-pedals','moza-r3-wheel-pedals-pc-copia','moza-r3-wheel-pedals-pc'],
  pedais: [
    'moza-mbooster-active-pedal-crp2-throttle','moza-crp2-load-cell-pedals-throttle-brake',
    'moza-srp2-pedals','moza-mbooster-active-pedal'
  ],
  pedais_adicionais: [
    'moza-crp2-full-length-throttle-replacement-plate','moza-crp2-performance-kit',
    'moza-crp2-load-cell-clutch-pedal','moza-srp2-clutch-pedal'
  ],
  suporte_monitor: ['suporte-de-piso-para-1-monitor-1'],
  suportes: [
    'suporte-deslizante-para-pedais','suporte-de-teclado-para-cockpit-suzuka',
    'suporte-de-computador-para-cockpit-suzuka','suporte-traseiro-45cm-compativel-com-cockpit-monza',
    'suporte-de-teclado-para-cockpit-interlagos'
  ],
  volantes: [
    'moza-porsche-mission-r-steering-wheel','moza-essenza-scv12-steering-wheel','moza-tsw-truck-wheel',
    'moza-gs-v2p-gt-wheel','moza-ks-pro-steering-wheel','moza-cs-pro-steering-wheel',
    'moza-cs-v2p-steering-wheel','moza-vision-gs-wheel','moza-ks-steering-wheel','moza-fsr2-formula-wheel'
  ]
};
function expand(...groups) { return groups.flat(); }
const TODOS = expand(
  G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits,
  G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
);
const TODOS_MENOS_R3_XBOX = TODOS.filter(h => h !== 'moza-r3-wheel-pedals-pc-copia');

const COMPAT = {
  'suporte-extensor-para-4-monitor-1': TODOS,
  'suporte-extensor-para-3-monitores-1': TODOS,
  'moza-clamp-for-truck-wheel': expand(
    G.bancos, G.cockpits, ['moza-base-extension-rod','moza-cm2-hd-racing-dash'],
    ['moza-crp2-full-length-throttle-replacement-plate','moza-crp2-load-cell-clutch-pedal'],
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-crp2-performance-kit'],
    ['moza-e-stop-switch'], G.cambios, G.bases, G.pedais, G.suportes, G.suporte_monitor, G.adicionais_monitor,
    ['moza-tsw-truck-wheel','moza-multi-function-stalks','moza-quick-release-adapter']
  ),
  'moza-12-inch-round-wheel-mod-for-es': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-es-formula-wheel-mod': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-table-clamp': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos,
    ['moza-r12-v2-direct-drive-wheel-base','moza-r9-v3-direct-drive-wheel-base'],
    G.cambios, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.volantes
  ),
  'moza-quick-release-adapter': TODOS,
  'moza-e-stop-switch': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos,
    ['moza-r21-ultra-direct-drive-wheel-base','moza-r25-ultra-true-torque-dd-wheel-base'],
    G.cambios,
    ['cockpit-profissional-interlagos','cockpit-suzuka-aluminio-4081'],
    G.extras, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'moza-multi-function-stalks': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-es-formula-wheel-mod','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-r3-wheel-pedals-pc','moza-r5-wheel-pedals'],
    G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes,
    ['moza-cs-pro-steering-wheel','moza-cs-v2p-steering-wheel','moza-tsw-truck-wheel']
  ),
  'moza-base-extension-rod': TODOS,
  'banco-sprint-tecido-alcantara-camurca-para-estrutura-de-cockpit-copia': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'banco-black-line-para-estrutura-de-cockpit-copia': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'banco-nitro-com-almofada-lombar-para-estrutura-de-cockpi': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'banco-black-line-para-estrutura-de-cockpit': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'banco-sprint-tecido-alcantara-camurca-para-estrutura-de-cockpit': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'banco-rosso-line-para-estrutura-de-cockpit': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-r21-ultra-direct-drive-wheel-base': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter'],
    G.bancos, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-suzuka-aluminio-4081'],
    G.extras, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'moza-r12-v2-direct-drive-wheel-base': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios,
    ['cockpit-monza-dobravel-3-geracao','cockpit-profissional-interlagos','cockpit-zolder-monocoluna','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-r9-v3-direct-drive-wheel-base': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios, G.cockpits, G.extras, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-r25-ultra-true-torque-dd-wheel-base': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter'],
    G.bancos, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-suzuka-aluminio-4081'],
    G.extras, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'moza-hgp-shifter': TODOS_MENOS_R3_XBOX,
  'moza-sgp-sequential-shifter': TODOS_MENOS_R3_XBOX,
  'moza-hbp-freio-de-mao': TODOS_MENOS_R3_XBOX,
  'cockpit-suzuka-aluminio-4081': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'cockpit-detroit-compact-dobravel': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter','moza-r9-v3-direct-drive-wheel-base'],
    G.cambios, G.extras, G.kits,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-srp2-pedals'],
    G.pedais_adicionais, G.suporte_monitor, G.volantes
  ),
  'cockpit-zolder-monocoluna': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter','moza-r12-v2-direct-drive-wheel-base','moza-r9-v3-direct-drive-wheel-base'],
    G.cambios, G.extras, G.kits,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-srp2-pedals'],
    G.pedais_adicionais, G.suporte_monitor, G.volantes
  ),
  'cockpit-spa': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter'],
    G.bancos,
    ['moza-r12-v2-direct-drive-wheel-base','moza-r9-v3-direct-drive-wheel-base'],
    G.cambios, G.extras, G.kits, G.pedais, G.pedais_adicionais,
    G.suporte_monitor, ['suporte-deslizante-para-pedais'], G.volantes
  ),
  'cockpit-profissional-interlagos': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'cockpit-monza-dobravel-3-geracao': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter','moza-r12-v2-direct-drive-wheel-base','moza-r9-v3-direct-drive-wheel-base'],
    G.cambios, G.extras, G.kits,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-srp2-pedals'],
    G.pedais_adicionais, G.suporte_monitor,
    ['suporte-traseiro-45cm-compativel-com-cockpit-monza','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'tapete-gamer-para-setup-de-cockpit': TODOS,
  'moza-universal-hub-kit': TODOS_MENOS_R3_XBOX,
  'moza-cm2-hd-racing-dash': TODOS_MENOS_R3_XBOX,
  'moza-r5-wheel-pedals': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios, G.cockpits, G.extras, G.suporte_monitor, G.suportes
  ),
  'moza-r3-wheel-pedals-pc-copia': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-es-formula-wheel-mod','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cockpits, ['tapete-gamer-para-setup-de-cockpit'], G.suporte_monitor, G.suportes
  ),
  'moza-r3-wheel-pedals-pc': expand(
    G.adicionais_monitor,
    ['moza-12-inch-round-wheel-mod-for-es','moza-base-extension-rod','moza-es-formula-wheel-mod','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.cambios, G.cockpits, G.extras, G.suporte_monitor, G.suportes
  ),
  'moza-mbooster-active-pedal-crp2-throttle': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras,
    ['moza-crp2-full-length-throttle-replacement-plate','moza-crp2-load-cell-clutch-pedal','moza-crp2-performance-kit'],
    G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'moza-crp2-load-cell-pedals-throttle-brake': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-crp2-full-length-throttle-replacement-plate','moza-crp2-load-cell-clutch-pedal','moza-crp2-performance-kit'],
    G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-srp2-pedals': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-srp2-clutch-pedal'], G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-mbooster-active-pedal': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras,
    ['moza-crp2-full-length-throttle-replacement-plate','moza-crp2-load-cell-clutch-pedal','moza-crp2-performance-kit'],
    G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-suzuka','suporte-de-teclado-para-cockpit-interlagos','suporte-deslizante-para-pedais'],
    G.volantes
  ),
  'moza-crp2-full-length-throttle-replacement-plate': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-mbooster-active-pedal-crp2-throttle','moza-crp2-load-cell-clutch-pedal','moza-crp2-performance-kit'],
    G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-crp2-performance-kit': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-mbooster-active-pedal-crp2-throttle','moza-crp2-load-cell-clutch-pedal','moza-crp2-full-length-throttle-replacement-plate'],
    G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-crp2-load-cell-clutch-pedal': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-crp2-load-cell-pedals-throttle-brake','moza-mbooster-active-pedal','moza-mbooster-active-pedal-crp2-throttle','moza-crp2-full-length-throttle-replacement-plate','moza-crp2-performance-kit'],
    G.suporte_monitor, G.suportes, G.volantes
  ),
  'moza-srp2-clutch-pedal': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios, G.cockpits, G.extras,
    ['moza-srp2-pedals'], G.suporte_monitor, G.suportes, G.volantes
  ),
  'suporte-de-piso-para-1-monitor-1': TODOS,
  'suporte-deslizante-para-pedais': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-monza-dobravel-3-geracao','cockpit-profissional-interlagos','cockpit-spa','cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes, G.volantes
  ),
  'suporte-de-teclado-para-cockpit-suzuka': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-computador-para-cockpit-suzuka','suporte-deslizante-para-pedais'], G.volantes
  ),
  'suporte-de-computador-para-cockpit-suzuka': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-suzuka-aluminio-4081'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-de-teclado-para-cockpit-suzuka','suporte-deslizante-para-pedais'], G.volantes
  ),
  'suporte-traseiro-45cm-compativel-com-cockpit-monza': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-monza-dobravel-3-geracao'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-deslizante-para-pedais'], G.volantes
  ),
  'suporte-de-teclado-para-cockpit-interlagos': expand(
    G.adicionais_monitor, G.adicionais_volante_base, G.bancos, G.bases, G.cambios,
    ['cockpit-profissional-interlagos'],
    G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor,
    ['suporte-deslizante-para-pedais'], G.volantes
  ),
  'moza-porsche-mission-r-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-essenza-scv12-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-tsw-truck-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-gs-v2p-gt-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-ks-pro-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-clamp-for-truck-wheel','moza-e-stop-switch','moza-multi-function-stalks','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-cs-pro-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-cs-v2p-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-vision-gs-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-ks-steering-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  ),
  'moza-fsr2-formula-wheel': expand(
    G.adicionais_monitor,
    ['moza-base-extension-rod','moza-e-stop-switch','moza-quick-release-adapter','moza-table-clamp'],
    G.bancos, G.bases, G.cambios, G.cockpits, G.extras, G.kits, G.pedais, G.pedais_adicionais, G.suporte_monitor, G.suportes
  )
};
const COMPAT_SETS = {};
for (const [handle, list] of Object.entries(COMPAT)) COMPAT_SETS[handle] = new Set(list);

/* ============================================================
   COMPATIBILIDADE / VISIBILIDADE — mesma lógica original
   ============================================================ */
function isProductCompatible(card, excludeStep) {
  const cardPlatform = (card.dataset.productPlatform || 'pc').toLowerCase();
  if (state.platform) {
    const platforms = cardPlatform.split(',').map(p => p.trim());
    if (!platforms.includes(state.platform)) return false;
  }
  const candidateHandle = card.dataset.productHandle;
  if (!candidateHandle) return true;

  const allSelected = [];
  Object.entries(state.selections).forEach(([step, val]) => {
    if (step === excludeStep) return;
    if (Array.isArray(val)) val.forEach(s => { if (s && !s.skip) allSelected.push(s); });
    else if (val && !val.skip) allSelected.push(val);
  });
  if (allSelected.length === 0) return true;

  const unlockedHandles = new Set();
  for (const sel of allSelected) if (sel.unlockHandles) sel.unlockHandles.forEach(h => unlockedHandles.add(h));

  for (const sel of allSelected) {
    const selHandle = sel.handle;
    if (!selHandle) continue;
    if (unlockedHandles.has(selHandle)) continue;
    const compatSet = COMPAT_SETS[selHandle];
    if (!compatSet) continue;
    if (!compatSet.has(candidateHandle)) return false;
  }
  return true;
}

function refreshStepCards(stepHandle) {
  const section = $(`#acc-${stepHandle}`);
  if (!section) return;
  $$('.msc-product-card:not(.msc-product-card--skip)', section).forEach(card => {
    const compat = isProductCompatible(card, stepHandle);
    card.classList.toggle('disabled', !compat);
    if (card.classList.contains('selected') && !compat) deselectCard(card, false);
  });
}
function refreshAllCards() { STEP_ORDER.forEach(refreshStepCards); }

function applyHiddenCategories() {
  const newHidden = new Set();
  Object.values(state.selections).forEach(val => {
    const sels = Array.isArray(val) ? val : [val];
    sels.forEach(sel => { if (sel && sel.hiddenCategories) sel.hiddenCategories.forEach(h => h && newHidden.add(h)); });
  });
  state.hiddenSteps = newHidden;
}

function isStepVisible(stepHandle) {
  if (state.hiddenSteps.has(stepHandle)) return false;
  const requiredStep = CONDITIONAL_STEPS[stepHandle];
  if (requiredStep) {
    const req = state.selections[requiredStep];
    if (!req) return false;
    const sels = Array.isArray(req) ? req : [req];
    if (sels.every(s => s.skip)) return false;
  }
  return true;
}
function getVisibleSteps() { return STEP_ORDER.filter(isStepVisible); }

function applyStepVisibilityToDOM() {
  STEP_ORDER.forEach(handle => {
    const item = $(`#acc-${handle}`);
    if (!item) return;
    const visible = isStepVisible(handle);
    item.style.display = visible ? '' : 'none';
    if (!visible && item.classList.contains('open')) closeAccordionItem(item);
  });
}

/* ============================================================
   ACORDEÃO
   ============================================================ */
function scrollToStepItem(item) {
  if (!item) return;
  // Mobile: não existe painel de imagem, só rola a categoria pro topo com uma margem
  if (window.innerWidth <= 900) {
    const rect = item.getBoundingClientRect();
    const targetY = window.scrollY + rect.top - 12;
    window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
    return;
  }
  const layout = $('.msc-layout');
  if (!layout) { item.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }

  // Ponto em que o painel de imagem (sticky) se soltaria do topo — nunca passamos disso
  const layoutRect = layout.getBoundingClientRect();
  const layoutBottom = layoutRect.bottom + window.scrollY;
  const maxScroll = Math.max(layoutBottom - window.innerHeight, 0);

  const itemRect = item.getBoundingClientRect();
  const targetY = window.scrollY + itemRect.top - 12;

  const clamped = Math.min(Math.max(targetY, 0), maxScroll);
  window.scrollTo({ top: clamped, behavior: 'smooth' });
}
function closeAccordionItem(item) {
  item.classList.remove('open');
  const body = $('.msc-accordion-body', item);
  if (body) body.style.display = 'none';
}
function openAccordionItem(item) {
  $$('.msc-accordion-item.open').forEach(el => { if (el !== item) closeAccordionItem(el); });
  item.classList.add('open');
  const body = $('.msc-accordion-body', item);
  if (body) body.style.display = 'block';
  state.openStep = item.dataset.step;
  setTimeout(() => scrollToStepItem(item), 60);
}
function toggleAccordionItem(item) {
  if (item.classList.contains('locked')) return;
  if (item.classList.contains('open')) closeAccordionItem(item);
  else openAccordionItem(item);
}
function openNextStepAfter(currentStepHandle) {
  const visible = getVisibleSteps();
  const idx = visible.indexOf(currentStepHandle);
  const next = visible[idx + 1];
  const currentItem = $(`#acc-${currentStepHandle}`);
  if (currentItem) closeAccordionItem(currentItem);
  if (next) {
    const nextItem = $(`#acc-${next}`);
    if (nextItem) openAccordionItem(nextItem);
  } else {
    setTimeout(() => {
      const donePanel = $('#msc-done-panel');
      if (donePanel && donePanel.style.display !== 'none') scrollToStepItem(donePanel);
    }, 80);
  }
}

/* ============================================================
   PAINEL DE IMAGEM (esquerda / desktop)
   ============================================================ */
function formatPrice(cents) { return 'R$ ' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 }); }

function setImagePanel(data) {
  const img = $('#msc-active-image');
  const placeholder = $('#msc-image-placeholder');
  const title = $('#msc-active-title');
  const desc = $('#msc-active-desc');
  const price = $('#msc-active-price');
  if (!img) return;
  if (!data || !data.image) {
    img.style.display = 'none';
    if (placeholder) placeholder.style.display = 'flex';
    if (title) title.textContent = '';
    if (desc) desc.textContent = '';
    if (price) price.textContent = '';
    return;
  }
  img.src = data.image;
  img.alt = data.title || '';
  img.style.display = 'block';
  if (placeholder) placeholder.style.display = 'none';
  if (title) title.textContent = data.title || '';
  if (desc) desc.textContent = data.desc || '';
  if (price) price.textContent = data.price != null ? formatPrice(data.price) : '';
}
function previewFromCard(card) {
  if (!card || card.dataset.skip === 'true') return;
  setImagePanel({
    image: card.dataset.productImageLarge || card.dataset.productImage,
    title: card.dataset.productTitle,
    desc: card.dataset.productDesc,
    price: parseInt(card.dataset.productPrice || '0', 10)
  });
}
function restoreConfirmedImage() { setImagePanel(state.confirmedImage); }

/* ============================================================
   QUICKVIEW — modal "Ver mais" (galeria + descrição completa)
   ============================================================ */
const quickview = {
  images: [],
  activeIndex: 0
};

function openQuickview(card) {
  if (!card || card.dataset.skip === 'true') return;

  const modal = $('#msc-quickview');
  if (!modal) return;

  const title = card.dataset.productTitle || '';
  const vendor = card.dataset.productVendor || '';
  const price = parseInt(card.dataset.productPrice || '0', 10);

  const rawImages = (card.dataset.productImages || '').split(',').map(s => s.trim()).filter(Boolean);
  const fallbackImage = card.dataset.productImageLarge || card.dataset.productImage;
  quickview.images = rawImages.length > 0 ? rawImages : (fallbackImage ? [fallbackImage] : []);
  quickview.activeIndex = 0;

  $('#msc-quickview-vendor').textContent = vendor;
  $('#msc-quickview-title').textContent = title;
  $('#msc-quickview-price').textContent = price ? formatPrice(price) : '';

  // Conteúdo: Especificações Técnicas / Itens Inclusos / Destaques / Precauções
  // (vem de um <template> escondido dentro do card). Se nenhum desses
  // metafields estiver preenchido, cai de volta pra descrição simples do produto.
  const descEl = $('#msc-quickview-desc');
  descEl.innerHTML = '';
  const specsTemplate = card.querySelector('template.msc-product-specs');
  const hasSpecs = specsTemplate && specsTemplate.content && specsTemplate.content.children.length > 0;
  if (hasSpecs) {
    descEl.appendChild(specsTemplate.content.cloneNode(true));
  } else {
    const fallbackDesc = card.dataset.productFullDesc || card.dataset.productDesc || '';
    if (fallbackDesc) {
      const p = document.createElement('p');
      p.className = 'msc-spec-content';
      p.textContent = fallbackDesc;
      descEl.appendChild(p);
    }
  }

  renderQuickviewGallery();

  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function renderQuickviewGallery() {
  const mainImg = $('#msc-quickview-main-img');
  const thumbsWrap = $('#msc-quickview-thumbs');
  if (!mainImg || !thumbsWrap) return;

  const current = quickview.images[quickview.activeIndex] || quickview.images[0] || '';
  mainImg.src = current;
  mainImg.alt = $('#msc-quickview-title').textContent || '';

  if (quickview.images.length <= 1) {
    thumbsWrap.innerHTML = '';
    return;
  }

  thumbsWrap.innerHTML = quickview.images.map((src, i) => `
    <button type="button" class="msc-quickview-thumb${i === quickview.activeIndex ? ' active' : ''}" data-index="${i}">
      <img src="${src}" alt="">
    </button>
  `).join('');

  $$('.msc-quickview-thumb', thumbsWrap).forEach(btn => {
    btn.addEventListener('click', () => {
      quickview.activeIndex = parseInt(btn.dataset.index, 10) || 0;
      renderQuickviewGallery();
    });
  });
}

function closeQuickview() {
  const modal = $('#msc-quickview');
  if (!modal) return;
  modal.classList.remove('open');
  document.body.style.overflow = '';
}

/* ============================================================
   SELEÇÃO DE PRODUTOS
   ============================================================ */
function buildSelData(card) {
  return {
    skip: card.dataset.skip === 'true',
    productId: card.dataset.productId || null,
    handle: card.dataset.productHandle || null,
    title: card.dataset.productTitle || 'Não quero',
    desc: card.dataset.productDesc || '',
    price: parseInt(card.dataset.productPrice || '0', 10),
    image: card.dataset.productImage || '',
    imageLarge: card.dataset.productImageLarge || card.dataset.productImage || '',
    hiddenCategories: (card.dataset.hiddenCategories || '').split(',').map(s => s.trim()).filter(Boolean),
    unlockHandles: (card.dataset.unlockHandles || '').split(',').map(s => s.trim()).filter(Boolean)
  };
}

function updateNextBtn(step) {
  const btn = $(`.msc-btn-next[data-step="${step}"]`);
  if (!btn) return;
  const val = state.selections[step];
  const has = !!val && (Array.isArray(val) ? val.length > 0 : true);
  btn.disabled = !has;
  btn.classList.toggle('ready', has);
}

function updateHeaderState(step) {
  const item = $(`#acc-${step}`);
  const label = $(`#sel-label-${step}`);
  if (!item || !label) return;
  const val = state.selections[step];
  if (!val || (Array.isArray(val) && val.length === 0)) {
    item.classList.remove('has-selection');
    label.textContent = '';
    return;
  }
  item.classList.add('has-selection');
  const sels = Array.isArray(val) ? val : [val];
  const nonSkip = sels.filter(s => !s.skip);
  if (nonSkip.length === 0) {
    label.textContent = 'Não quero ✓';
  } else if (nonSkip.length === 1) {
    label.textContent = nonSkip[0].title + ' ✓';
  } else {
    label.textContent = nonSkip.length + ' itens ✓';
  }
}

function selectCard(card, stepHandle) {
  const section = $(`#acc-${stepHandle}`);
  const isMulti = MULTI_STEPS.has(stepHandle);
  const isSkip = card.dataset.skip === 'true';

  if (!isMulti || isSkip) {
    $$('.msc-product-card.selected', section).forEach(prev => deselectCard(prev, false));
    card.classList.add('selected');
    const btn = $('.msc-btn-select', card);
    if (btn && !isSkip) btn.textContent = 'Selecionado ✓';
    state.selections[stepHandle] = buildSelData(card);
  } else {
    $$('.msc-product-card--skip.selected', section).forEach(prev => deselectCard(prev, false));
    card.classList.add('selected');
    const btn = $('.msc-btn-select', card);
    if (btn) btn.textContent = 'Selecionado ✓';
    const existing = Array.isArray(state.selections[stepHandle]) ? state.selections[stepHandle] : [];
    existing.push(buildSelData(card));
    state.selections[stepHandle] = existing;
  }

  if (!isSkip) {
    const data = { image: card.dataset.productImageLarge || card.dataset.productImage, title: card.dataset.productTitle, desc: card.dataset.productDesc, price: parseInt(card.dataset.productPrice || '0', 10) };
    state.confirmedImage = data;
    setImagePanel(data);
  }

  applyHiddenCategories();
  refreshAllCards();
  applyStepVisibilityToDOM();
  updateBottomBar();
  updateHeaderState(stepHandle);
  updateNextBtn(stepHandle);

  if (isSkip) setTimeout(() => openNextStepAfter(stepHandle), 260);
}

function deselectCard(card, updateState = true) {
  card.classList.remove('selected');
  const btn = $('.msc-btn-select', card);
  if (btn) btn.textContent = card.dataset.skip === 'true' ? 'Selecionar' : 'Adicionar';

  if (updateState) {
    const step = card.dataset.step;
    const isMulti = MULTI_STEPS.has(step);
    if (isMulti && Array.isArray(state.selections[step])) {
      const handle = card.dataset.productHandle;
      state.selections[step] = state.selections[step].filter(s => s.handle !== handle);
      if (state.selections[step].length === 0) delete state.selections[step];
    } else {
      delete state.selections[step];
    }
    applyHiddenCategories();
    refreshAllCards();
    applyStepVisibilityToDOM();
    updateBottomBar();
    updateHeaderState(step);
    updateNextBtn(step);
  }
}

function removeSelection(step, handle) {
  const card = handle ? $(`.msc-product-card[data-product-handle="${handle}"][data-step="${step}"]`) : null;
  if (card) {
    deselectCard(card, true);
    return;
  }
  if (MULTI_STEPS.has(step) && Array.isArray(state.selections[step])) {
    state.selections[step] = state.selections[step].filter(s => s.handle !== handle);
    if (state.selections[step].length === 0) delete state.selections[step];
  } else {
    delete state.selections[step];
  }
  applyHiddenCategories();
  refreshAllCards();
  applyStepVisibilityToDOM();
  updateBottomBar();
  updateHeaderState(step);
  updateNextBtn(step);
}

/* ============================================================
   BARRA INFERIOR + PAINEL MOBILE
   ============================================================ */
function isStepAnswered(step) {
  const val = state.selections[step];
  if (!val) return false;
  if (Array.isArray(val)) return val.length > 0;
  return true;
}
function isBuilderComplete() {
  if (!state.platform) return false;
  const visible = getVisibleSteps();
  if (visible.length === 0) return false;
  return visible.every(isStepAnswered);
}
function updateDonePanel() {
  const panel = $('#msc-done-panel');
  if (!panel) return;
  panel.style.display = isBuilderComplete() ? 'flex' : 'none';
}

function getAllSelectedItems() {
  const items = [];
  Object.entries(state.selections).forEach(([step, val]) => {
    const sels = Array.isArray(val) ? val : [val];
    sels.forEach(s => { if (s && !s.skip) items.push({ step, sel: s }); });
  });
  return items;
}

function updateBottomBar() {
  updateDonePanel();
  const items = getAllSelectedItems();
  const thumbsEl = $('#msc-bottom-thumbs');
  const listEl = $('#msc-mobile-sheet-list');
  const totalEl = $('#msc-total');
  const toggleTotalEl = $('#msc-bottom-toggle-total');
  const cartBtn = $('#msc-btn-cart');
  const clearBtn = $('#msc-btn-clear');
  const countEl = $('#msc-bottom-count');

  countEl.textContent = items.length;

  if (items.length === 0) {
    thumbsEl.innerHTML = '<p class="msc-empty-state">Nenhum item selecionado ainda.</p>';
    listEl.innerHTML = '<p class="msc-empty-state">Nenhum item selecionado ainda.</p>';
    totalEl.textContent = 'R$ 0,00';
    if (toggleTotalEl) toggleTotalEl.textContent = 'R$ 0,00';
    cartBtn.disabled = true;
    clearBtn.disabled = true;
    return;
  }

  let total = 0;
  thumbsEl.innerHTML = items.map(({ step, sel }) => {
    total += sel.price;
    return `<div class="msc-thumb-item" title="${sel.title}">
      ${sel.image ? `<img src="${sel.image}" alt="${sel.title}">` : ''}
      <button type="button" class="msc-thumb-remove" data-step="${step}" data-handle="${sel.handle || ''}">✕</button>
    </div>`;
  }).join('');

  listEl.innerHTML = items.map(({ step, sel }) => `
    <div class="msc-selection-item">
      ${sel.image ? `<img src="${sel.image}" alt="${sel.title}">` : ''}
      <div class="msc-selection-info">
        <div class="msc-selection-cat">${LABELS[step] || step}</div>
        <div class="msc-selection-name">${sel.title}</div>
        <div class="msc-selection-price">${formatPrice(sel.price)}</div>
      </div>
      <button type="button" class="msc-selection-remove" data-step="${step}" data-handle="${sel.handle || ''}" title="Remover">✕</button>
    </div>`).join('');

  $$('.msc-thumb-remove', thumbsEl).forEach(btn => {
    btn.addEventListener('click', (e) => { e.stopPropagation(); removeSelection(btn.dataset.step, btn.dataset.handle); });
  });
  $$('.msc-selection-remove', listEl).forEach(btn => {
    btn.addEventListener('click', (e) => { e.stopPropagation(); removeSelection(btn.dataset.step, btn.dataset.handle); });
  });

  totalEl.textContent = formatPrice(total);
  if (toggleTotalEl) toggleTotalEl.textContent = formatPrice(total);
  cartBtn.disabled = false;
  clearBtn.disabled = false;
}

/* ============================================================
   CARRINHO
   ============================================================ */
async function addToCart() {
  const allSels = getAllSelectedItems().map(i => i.sel).filter(s => s.productId);
  if (allSels.length === 0) return;
  const cartBtn = $('#msc-btn-cart');
  const originalText = cartBtn.textContent;
  cartBtn.textContent = 'Adicionando...';
  cartBtn.disabled = true;
  try {
    const lineItems = [];
    for (const item of allSels) {
      const resp = await fetch(`/products/${item.handle || item.productId}.js`);
      if (resp.ok) {
        const data = await resp.json();
        if (data.variants && data.variants.length > 0) lineItems.push({ id: data.variants[0].id, quantity: 1 });
      }
    }
    if (lineItems.length === 0) throw new Error('Nenhum produto válido.');
    const addResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    });
    if (!addResp.ok) throw new Error('Erro ao adicionar ao carrinho.');
    window.location.href = '/cart';
  } catch (e) {
    console.error('MSC cart error:', e);
    cartBtn.textContent = 'Erro. Tente novamente.';
    cartBtn.disabled = false;
    setTimeout(() => { cartBtn.textContent = originalText; cartBtn.disabled = false; }, 3000);
  }
}

/* ============================================================
   RESET
   ============================================================ */
function clearSelections() {
  state.selections = {};
  state.hiddenSteps = new Set();
  state.confirmedImage = null;
  $$('.msc-product-card.selected').forEach(c => {
    c.classList.remove('selected');
    const b = $('.msc-btn-select', c);
    if (b) b.textContent = c.dataset.skip === 'true' ? 'Selecionar' : 'Adicionar';
  });
  $$('.msc-product-card.disabled').forEach(c => c.classList.remove('disabled'));
  STEP_ORDER.forEach(updateHeaderState);
  STEP_ORDER.forEach(updateNextBtn);
  applyStepVisibilityToDOM();
  updateBottomBar();
  setImagePanel(null);
}

function resetPlatform() {
  state.platform = null;
  clearSelections();
  $$('.msc-platform-card').forEach(c => c.classList.remove('selected'));
  $('#sel-label-platform').textContent = '';
  STEP_ORDER.forEach(handle => {
    const item = $(`#acc-${handle}`);
    if (item) item.classList.add('locked');
  });
  const platformItem = $('#acc-platform');
  openAccordionItem(platformItem);
  $('#msc-builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ============================================================
   INIT
   ============================================================ */
function init() {
  // Plataforma
  $$('.msc-platform-card').forEach(card => {
    card.addEventListener('click', () => {
      const changing = state.platform && state.platform !== card.dataset.platform;
      $$('.msc-platform-card').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      state.platform = card.dataset.platform;
      $('#sel-label-platform').textContent = card.dataset.platform.toUpperCase() + ' ✓';

      if (changing) clearSelections();

      STEP_ORDER.forEach(handle => {
        const item = $(`#acc-${handle}`);
        if (item) item.classList.remove('locked');
      });
      refreshAllCards();
      applyStepVisibilityToDOM();
      openNextStepAfter('platform');
    });
  });

  // Cabeçalhos do acordeão
  $$('.msc-accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.msc-accordion-item');
      if (!item) return;
      if (item.dataset.step === 'platform') { toggleAccordionItem(item); return; }
      toggleAccordionItem(item);
    });
  });

  // Botão "Ver mais" — abre o quickview sem selecionar o produto
  $$('.msc-btn-more').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const card = btn.closest('.msc-product-card');
      openQuickview(card);
    });
  });

  // Cartões de produto
  $$('.msc-product-card').forEach(card => {
    card.addEventListener('click', () => {
      // Sem estoque: card renderizado (visível na grade) porém apagado e
      // inclicável — bloqueado tanto pelo CSS (pointer-events:none) quanto
      // aqui, como segunda barreira caso o CSS não tenha carregado a tempo.
      if (card.dataset.available === 'false') return;
      if (card.classList.contains('disabled')) return;
      const step = card.dataset.step;
      const isMulti = MULTI_STEPS.has(step);
      if (card.classList.contains('selected') && ((isMulti && card.dataset.skip !== 'true') || !isMulti)) {
        deselectCard(card);
      } else {
        selectCard(card, step);
      }
    });
    card.addEventListener('mouseenter', () => {
      if (card.dataset.available === 'false') return;
      if (window.innerWidth > 900) previewFromCard(card);
    });
    card.addEventListener('mouseleave', () => { if (window.innerWidth > 900) restoreConfirmedImage(); });
  });

  // Botão "Próxima categoria"
  $$('.msc-btn-next').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!btn.disabled) openNextStepAfter(btn.dataset.step);
    });
  });

  // Barra inferior
  $('#msc-btn-cart').addEventListener('click', addToCart);
  const doneBtn = $('#msc-btn-done-cart');
  if (doneBtn) doneBtn.addEventListener('click', addToCart);
  $('#msc-btn-clear').addEventListener('click', () => {
    clearSelections();
    const platformItem = $('#acc-platform');
    if (platformItem) openAccordionItem(platformItem);
  });

  // Painel mobile
  const sheet = $('#msc-mobile-sheet');
  $('#msc-bottom-toggle').addEventListener('click', () => sheet.classList.add('open'));
  $('#msc-mobile-sheet-close').addEventListener('click', () => sheet.classList.remove('open'));
  $('#msc-mobile-sheet-backdrop').addEventListener('click', () => sheet.classList.remove('open'));

  // Quickview ("Ver mais")
  const quickviewClose = $('#msc-quickview-close');
  const quickviewBackdrop = $('#msc-quickview-backdrop');
  if (quickviewClose) quickviewClose.addEventListener('click', closeQuickview);
  if (quickviewBackdrop) quickviewBackdrop.addEventListener('click', closeQuickview);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeQuickview();
  });

  // Estado inicial: tudo trancado até escolher plataforma
  STEP_ORDER.forEach(handle => {
    const item = $(`#acc-${handle}`);
    if (item) item.classList.add('locked');
  });
  updateBottomBar();

  // Evita que a barra fixa sobreponha o footer da loja: quando o final
  // do builder se aproxima da tela, ela "atraca" no rodapé do wrapper.
  const sentinel = $('#msc-bottom-sentinel');
  const bar = $('#msc-bottom-bar');
  if (sentinel && bar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        bar.classList.toggle('msc-bottom-bar--docked', entry.isIntersecting);
      });
    }, { root: null, threshold: 0 });
    observer.observe(sentinel);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
})();